// Không được để trống
export const required = (t) => (value) => !value ? t('required') : null

// Phải từ n đến m ký tự
export const lengthBetween = (min, max, t) => (value) => {
  if (!value) return null
  return value.length < min || value.length > max
    ? t('must be {n} to {m} chars', { n: min, m: max })
    : null
}

// Không chứa kí tự đặc biệt
export const noSpecialChars = (t) => (value) =>
  !/^[A-Za-zÀ-ỹ.\s'’-\d]+$/.test(value) ? t('no special chars') : null

// Không được chứa số
export const noNumber = (t) => (value) =>
  /\d/.test(value) ? t('no numbers') : null

// Không được có khoảng trắng hai đầu của chuỗi
export const noLeadingTrailingSpaces = (t) => (value) =>
  /^\s|\s$/.test(value) ? t('no leading or trailing spaces') : null

// Không được có hai khoảng trắng liên tiếp
export const noDoubleSpaces = (t) => (value) =>
  /\s{2,}/.test(value) ? t('no consecutive spaces') : null

// Chữ đầu tiên phải viết hoa
export const firstLetterUppercase = (t) => (value) =>
  !/^[A-ZÀ-Ỹ]/.test(value) ? t('first letter must be uppercase') : null

// Mỗi từ trong chuỗi phải viết hoa chữ cái đầu
export const eachWordUppercase = (t) => (value) =>
  !/^(?:[A-ZÀ-Ỹ][a-zà-ỹ]*)(?:\s[A-ZÀ-Ỹ][a-zà-ỹ]*)*$/.test(value)
    ? t('each word must start with uppercase')
    : null

// Ràng buộc email
export const emailFormat = (t) => (value) =>
  !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
    ? t('invalid email address')
    : null

// Phải từ n đến m chữ số
export const digitLength = (min, max, t) => (value) =>
    !new RegExp(`^\\d{${min},${max}}$`).test(value)
        ? t('must be between {n} and {m} digits', { n: min, m: max })
        : null

// Ràng buộc passport hợp lệ
export const passportFormart = (t) => (value) =>
  !/^[A-Z]\d{7}$/.test(value)
    ? t('must start with an uppercase letter followed by 7 digits')
    : null

// Ràng buộc parish hợp lệ
export const parishFormart = (t) => (value) =>
  !/^([’']?[A-Za-zÀ-ỹ][A-Za-zÀ-ỹ'’.-]*)(\s[’']?[A-Za-zÀ-ỹ][A-Za-zÀ-ỹ'’.-]*)*$/.test(
    value
  )
    ? t('invalid template')
    : null

// Ràng buộc url
export const urlFormat = (t) => (value) => {
  if (!value) return null
  return !/^https:\/\//i.test(value)
      ? t('invalid url')
      : null
}

export const runRules = (value, rules) => {
  for (const rule of rules) {
    const error = rule(value)
    if (error) return error
  }
  return null
}
